import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { validateNumber } from "../../../utils/validateFields";
import EditDialog from "../../../Components/Common/EditDialog";
import { get, post } from "../../../utils/api";
import SelectField from "../../../Components/Masters/SelectField";
import { monthlist } from "../../../utils/constant";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function AddMis({ inputData, setAddData, addData, setsnackOpen, handleClose }) {
  const [errors, setErrors] = useState({});

  const initialState = {
    month: "",
    year: "",
    typeOfReport: "Consolidated",
    facility: "",
  };
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startYear = 2013;
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i); // Full supported range through the current year

  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);

  const [filteredYears, setFilteredYears] = useState(years);
  const [disableValue, setDisableValue] = useState("");

  const [facilities, setFacility] = useState([]);

  const fetchFacilities = async () => {
    try {
      const response = await get(`/master/getAllFacility`);
      let arr = response?.data?.data.map((item) => ({
        value: item?._id,
        label: item?.facilityName,
      }));

      setFacility(arr);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  //   const handleClose = () => {
  //     setAddData(false);
  //     setErrors({});
  //     setFormData(initialState);
  //     setUploadedFiles(element?.documents || []); // Populate with existing documents
  //   };

  const validateForm = () => {
    const newErrors = {};

    const month = formData?.month;
    const year = formData?.year;

    if (!validateNumber(month)) newErrors["month"] = "Month is required";

    if (!validateNumber(year)) newErrors["year"] = "Year is required";

    setErrors(newErrors);
    console.log(newErrors, "new1");
    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false); // State to track loading

  const Save = async () => {
    if (!validateForm()) return;

    setLoading(true); // Start loading before request

    try {
      const response = await post("/mis-report/createMISReport", formData);
      const message = response?.data?.message;

      console.log(message, response);

      setsnackOpen({
        open: true,
        message:
          message || "Report generation is in progress, Check after 10 mins.",
        severity: "success",
      });

      setFormData(initialState);
      handleClose();
    } catch (error) {
      console.error("Save Error:", error);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = error.response.data.errors
          .map((err) => err.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else {
        setsnackOpen({
          open: true,
          message: error.message || "An error occurred while saving the data.",
          severity: "error",
        });
      }
    } finally {
      setLoading(false); // Stop loading after response (success or error)
    }
  };

  const handleExitAgree = () => {
    setErrors({});
    setEditDialog(false);
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  console.log("foermdata", formData);

  const handleMonthChange = (event) => {
    setDisableValue("");
    setErrors && setErrors({ ...errors, month: "" });
    const selectedMonthIndex = event.target.value;
    setFormData({
      ...formData,
      month: selectedMonthIndex,
    });
    if (selectedMonthIndex > currentMonth + 1) {
      setDisableValue(currentYear);
      if (formData?.consumptionPeriod?.year === currentYear)
        setFormData({
          ...formData,
          year: "",
        });
    }
  };

  const handleYearChange = (event) => {
    setErrors && setErrors({ ...errors, year: "" });
    setFormData({
      ...formData,
      year: event.target.value, // Update the 'year' field within 'consumptionPeriod'
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{ width: "26rem", maxWidth: "100%", height: "100%" }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Generate MIS Report
        </Typography>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-0.5rem" }}
          >
            Month
          </Typography>
          <SelectField
            name={"Month"}
            value={formData?.month}
            handleChange={handleMonthChange}
            label="Month"
            field="month"
            errors={errors?.["month"] || ""}
            defaultValue={"Month"}
            options={monthlist} // Month options as strings
          />
        </Box>

        {/* Year Input */}
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-0.5rem" }}
          >
            Year
          </Typography>
          <SelectField
            name={"Year"}
            value={formData?.year}
            handleChange={handleYearChange}
            options={filteredYears}
            errors={errors?.["year"] || ""}
            defaultValue={"Year"}
            menuDisable={disableValue}
          />
        </Box>

        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1, mt: 1 }}
          >
            Type
          </Typography>
          <Select
            labelId="report-type-label"
            id="typeOfReport"
            name="typeOfReport"
            size="small"
            fullWidth
            value={formData?.typeOfReport}
            onChange={handleChange}
          >
            <MenuItem value="Consolidated">Consolidated</MenuItem>
            <MenuItem value="Facility">Facility</MenuItem>
          </Select>
          {errors?.typeOfReport && (
            <FormHelperText>{errors.typeOfReport}</FormHelperText>
          )}
        </Box>

        {formData?.typeOfReport === "Facility" ? (
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
            >
              Facility
            </Typography>
            <Select
              labelId="facility-label"
              id="facility"
              name="facility"
              size="small"
              fullWidth
              value={formData?.facility || "Select Facility"}
              onChange={handleChange}
              defaultValue=""
            >
              <MenuItem value="Select Facility" disabled>
                Select Facility
              </MenuItem>
              {facilities.map((facility) => (
                <MenuItem key={facility.value} value={facility.value}>
                  {facility.label}
                </MenuItem>
              ))}
            </Select>

            {errors?.facility && (
              <FormHelperText>{errors.facility}</FormHelperText>
            )}
          </Box>
        ) : null}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {list()}
    </Drawer>
  );
}

export default AddMis;